import React, { useMemo } from "react";
import { KeyboardReturn } from "@mui/icons-material";
import { useDialog } from "../../../global/utils/dialog/DialogProvider.tsx";
import store, { useAppSelector } from "../../../global/utils/redux/store.tsx";
import { ListItem, ListItemButton, ListItemIcon, ListItemText } from "@mui/material";
import { useIntl } from "react-intl";
import clsx from "clsx";
import TicketPincodeDialog from "../TicketPincode/TicketPincodeDialog.tsx";
import { useGoToHomeQr } from "../../pages/ReturnPage/ReturnPage.tsx";

export default function useExitToHomePageListItem() {
  const { openDialog, closeDialog } = useDialog();

  const goToHome = useGoToHomeQr();
  const intl = useIntl();
  const exitUrl = useAppSelector((state) => state.global.salesarea.custom_data.exit_url);

  return useMemo(
    () =>
      exitUrl ? (
        <ListItem className={clsx("JS-SideMenuDrawer-ListItem")} key={"EXIT"} disablePadding>
          <ListItemButton
            onClick={() => {
              const pincode = store.getState().global.salesarea.custom_data?.tablets?.exit_pincode;

              openDialog({
                disabledBackdropClick: false,
                children: (
                  <TicketPincodeDialog
                    onClose={() => {
                      closeDialog();
                    }}
                    numberOfDigits={pincode?.length ?? 4}
                    onPincodeEntered={(pincode) => {
                      return new Promise<boolean>((resolve) => {
                        const exitPincode = store.getState().global.salesarea.custom_data?.tablets?.exit_pincode;

                        if (!exitPincode || pincode === exitPincode) {
                          resolve(true);
                          goToHome(exitUrl);
                          closeDialog();
                        } else {
                          resolve(false);
                        }
                      });
                    }}
                  />
                ),
              });
            }}
          >
            <ListItemIcon className={"JS-SideDrawerMenu-ItemIcon"}>
              <KeyboardReturn />
            </ListItemIcon>
            <ListItemText primary={intl.formatMessage({ id: "Exit" })} />
          </ListItemButton>
        </ListItem>
      ) : null,
    [exitUrl, intl, openDialog, closeDialog, goToHome]
  );
}
